import { APIModel } from "./api-model";
import { NonRecovery } from "./non-recovery";
import { Opo } from "./opo";

/**
 * Class to store Donor information coming from the API
 */
export class Donor extends APIModel {
  id: string;
  code: string;
  opo: Opo;
  birthsex: string;
  gender: string;
  dcd_criteria_meets: string;
  blood_type: string;
  age: string;
  kdpi: string;
  non_recovery: NonRecovery;

  static fieldsToMap = {
    direct: [
      'id',
      'opo_id',
      'non_recovery_id',
      'code',
      'created_at',
      'updated_at',
      'blood_type',
      'bmi',
      'hospital',
      'city',
      'admit_date_time',
      'age',
      'height',
      'kdpi',
      'weight',
      'gender',
      'race_ethnicity',
      'or_datetime',
      'dob',
      'medical_and_social_history_comments',
      'admission_course_comments',
      'processing_started_at',
      'processing_error',
      'processing_status',
      'processing_completed_at',
      'non_recovery_id',
      'highlights',
      'race',
      'ethnicity',
      'cross_clamp_datetime',
    ],
    formatDcdCriteria: [
      'dcd_criteria_meets'
    ],
    formatDateTimeWithTimezone: [
      'cross_clamp_datetime',
      'or_datetime'
    ]
  }

  static buildFromAPI(record: any): Donor {
    const donor = new Donor();
    record = record || {};

    this.mapFieldsDirectly<Donor>(Donor.fieldsToMap.direct, record, donor);
    this.mapFormatDateTimeWithTimezone<Donor>(Donor.fieldsToMap.formatDateTimeWithTimezone, record, donor, record?.provider_informations[0]?.time_zone);
    this.mapFormatDcdOrBd<Donor>(Donor.fieldsToMap.formatDcdCriteria, record, donor);

    
    donor.opo = Opo.buildFromAPI(record.opo);
    donor.non_recovery = NonRecovery.buildFromAPI(record.non_recovery)

    return donor;
  }

  static mapFormatDcdOrBd<T>(fieldsToMap: Array<string>, from: any, to: T) {
    fieldsToMap.forEach((k) => {
      const val = from[k];
      let display = '';
      if(val === true) {
        display = 'DCD'
      } else if(val === false) {
        display = 'BD'
      } else {
        display = 'N/A'
      }
  
      to[k] = { value: val, display: display };
    });
  }
}